module.exports = __webpack_public_path__ + "static/media/Partner10.81abe6f5.webp";